import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";

import Home from "@/pages/Home";
import CommonNumber from "@/pages/CommonNumber";
import DreamNumber from "@/pages/DreamNumber";
import PreviousResult from "@/pages/PreviousResult";
import StaticPage from "@/pages/StaticPage";
import Blog from "@/pages/Blog";
import TeerCalendar from "@/pages/TeerCalendar";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/common-number" element={<CommonNumber />} />
          <Route path="/dream-number" element={<DreamNumber />} />
          <Route path="/previous-result" element={<PreviousResult />} />

          {/* Static / Coming-soon pages */}
          <Route path="/blog" element={<Blog />} />
          <Route
            path="/predict-number"
            element={
              <StaticPage
                title="Predict Number"
                description="AI-powered prediction based on historical trends. Coming soon."
              />
            }
          />
          <Route
            path="/predict-target"
            element={
              <StaticPage
                title="Predict Target"
                description="Predict the Direct, House and Ending of upcoming rounds. Coming soon."
              />
            }
          />
          <Route path="/teer-calendar" element={<TeerCalendar />} />
          <Route
            path="/reputed-counter"
            element={
              <StaticPage
                title="Reputed Counter"
                description="List of trusted Teer counters. Coming soon."
              />
            }
          />
          <Route
            path="/night-teer-app"
            element={
              <StaticPage
                title="Night Teer App"
                description="Download our mobile app. Coming soon."
              />
            }
          />
          <Route
            path="/about"
            element={
              <StaticPage
                title="About Us"
                description="Night Teer is a free platform to view live Night Teer results, common numbers, dream numbers and previous results. This site is for information and entertainment only."
              />
            }
          />
          <Route
            path="/terms"
            element={
              <StaticPage
                title="Terms and Conditions"
                description="By using this website you agree that Night Teer is a game of luck and this platform is only for information & entertainment purposes. We do not organise or promote gambling."
              />
            }
          />
          <Route
            path="/privacy"
            element={
              <StaticPage
                title="Privacy Policy"
                description="We do not collect any personal information from visitors. Ads and analytics may use cookies according to the respective provider's policy."
              />
            }
          />
          <Route
            path="/contact"
            element={
              <StaticPage
                title="Contact Us"
                description="For any query or feedback, reach us through our social media channels linked at the footer of every page."
              />
            }
          />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
